// =============================================================================
// trackerActionTypes.js
//
// Constantes de action types do Tracker.
//
// Porquê usar constantes em vez de strings directas?
//   → Typos numa string passam silenciosamente (ex: "FETCH_SUCCES").
//   → Com constantes, o IDE avisa imediatamente se o nome estiver errado.
//
// Convenção: "MÓDULO/ACÇÃO_ESTADO"
// =============================================================================

const TRACKER = {
	// Carregar lista de entradas (tabela)
	FETCH_REQUEST: 'TRACKER/FETCH_REQUEST',
	FETCH_SUCCESS: 'TRACKER/FETCH_SUCCESS',
	FETCH_FAILURE: 'TRACKER/FETCH_FAILURE',

	// Carregar uma entrada completa (modal de edição)
	FETCH_ONE_REQUEST: 'TRACKER/FETCH_ONE_REQUEST',
	FETCH_ONE_SUCCESS: 'TRACKER/FETCH_ONE_SUCCESS',
	FETCH_ONE_FAILURE: 'TRACKER/FETCH_ONE_FAILURE',

	// Criar nova entrada
	CREATE_REQUEST: 'TRACKER/CREATE_REQUEST',
	CREATE_SUCCESS: 'TRACKER/CREATE_SUCCESS',
	CREATE_FAILURE: 'TRACKER/CREATE_FAILURE',

	// Actualizar entrada existente
	UPDATE_REQUEST: 'TRACKER/UPDATE_REQUEST',
	UPDATE_SUCCESS: 'TRACKER/UPDATE_SUCCESS',
	UPDATE_FAILURE: 'TRACKER/UPDATE_FAILURE',

	// Apagar entrada
	DELETE_REQUEST: 'TRACKER/DELETE_REQUEST',
	DELETE_SUCCESS: 'TRACKER/DELETE_SUCCESS',
	DELETE_FAILURE: 'TRACKER/DELETE_FAILURE',

	// Estado do modal
	OPEN_MODAL:  'TRACKER/OPEN_MODAL',
	CLOSE_MODAL: 'TRACKER/CLOSE_MODAL',

	// Limpar erros
	CLEAR_ERROR: 'TRACKER/CLEAR_ERROR',
};

export default TRACKER;